import React, { useState, useEffect } from "react";
import {
    Row,
    Col,
    Form,
    FormGroup,
    ControlLabel,
    FormControl,
    InputGroup,
    Modal
} from "react-bootstrap";
import Select from "react-select";
import { useSelector, useDispatch } from "react-redux";
import * as API from '../../api/billing'
import * as actionTypes from "Front/actions/actionTypes";
import moment from "moment";
import { all } from "axios";

const billTypeOptions = [
    { value: "Paid", label: "Paid" },
    { value: "Free", label: "Free" },
    // Add more options as needed
];

const BillingInfo = ({
    allProps,
    allState,
    addServiceToBill,
    handleFillOldPatientLatestBillDetails,
    totalPaidAmount,
    handleTotalPaidAmount,
    handleUpdateServicesOnConsultationChange,
    handleBillChange,
    clearBillDetails,
    handlePaymentMode,
    onBillingDisabledChange,
    parentComponent = '',
    isBillingDisabled

}) => {
    const [billOptions, setBillOptions] = useState([]);
    const [latestBill, setLatestBill] = useState(null);
    const [billType, setBillType] = useState("");
    const [billCategoryOptions, setBillCategoryOptions] = useState([]);
    const [billCategory, setBillCategory] = useState(null);
    const [billSubCategoryOptions, setBillSubCategoryOptions] = useState([]);
    const [billSubCategory, setBillSubCategory] = useState(null);
    const [paymentMode, setPaymentMode] = useState("Cash");
    // const [totalPaidAmount, setTotalPaidAmount] = useState("");
    const [hasUserEditedPaidAmount, setHasUserEditedPaidAmount] = useState(false);
    const [totalPaidAmountError, setTotalPaidAmountError] = useState("");
    const billingReduxData = useSelector((store) => store.billing);
    const [allLocalCategories, setAllLocalCategories] = useState(billingReduxData?.billCategoryList || []);
    const [allLocalSubCategories, setAllLocalSubCategories] = useState(billingReduxData?.billSubCategoryList || []);
    // const [isBillingDisabled, setIsBillingDisabled] = useState(false);
    const dispatch = useDispatch()

    const getPatientType = (createdAt) => {
        if (!createdAt) return 'new'; // Fallback: if date is missing, assume new

        const createdDate = moment(createdAt).utcOffset('+05:30'); // convert to IST
        const today = moment().utcOffset('+05:30');
        return createdDate.isSame(today, 'day') ? 'new' : 'old';
    };

    const patientType = parentComponent === "billing" ? "old" : getPatientType(allState?.createdAt);

    const handleBill = (selected) => {
        setLatestBill(selected);
        handleBillChange(selected)
        // Additional logic for selected bill
    };

    const handleChange = (event) => {
        const { name, value } = event.target;
        if (name === "billType") {
            setBillType(value);
            let catOptions = [];
            if (value === "Paid") {
                if (patientType === "new")
                    handleNewPatientDefaultBillingInfo()
                if (patientType === "old") {
                    const catOptions = billingReduxData?.billCategoryList.map((ele) => {
                        return {
                            label: ele?.name, value: ele?._id, ...ele
                        }
                    })
                    setBillCategoryOptions(catOptions);
                    setBillCategory(null)
                    setBillSubCategory(null)
                    setPaymentMode("Cash")
                }

                // const systemDefaultCategories = billingReduxData?.billCategoryList
                // catOptions = systemDefaultCategories.map((ele) => {
                //     return {
                //         label: ele?.name, value: ele?._id, ...ele
                //     }
                // })
                // console.log(catOptions, billingReduxData, "----systemDefaultCategories")
            }
            if (value === "Free") {
                setBillCategoryOptions(catOptions);
                setBillSubCategoryOptions([])
                clearBillDetails()
            }
        }
    };

    // useEffect(() => {
    //     if (onBillingDisabledChange) {
    //         onBillingDisabledChange();
    //     }
    // }, [isBillingDisabled, patientType]);


    const handleBillCategory = (selected) => {
        setBillCategory(selected);
        const allSubCategories = allLocalSubCategories
        if (allSubCategories?.length > 0) {
            const filteredSubcategories = allSubCategories?.filter((subCat) => subCat?.categoryId?._id === selected?._id)
            const filteredBillSubCategoryOptions = filteredSubcategories.map((ele) => {
                return {
                    label: ele?.name, value: ele?._id, ...ele
                }
            })
            setBillSubCategoryOptions(filteredBillSubCategoryOptions)
        }
    };



    const getBillCategoryList = async () => {
        let resp = await API.categoryList({});
        if (resp?.data?.status === "Success" && resp?.data?.statusCode === 200) {
            setAllLocalCategories(resp.data.data)
            const categoryOptions = resp.data.data.map((ele) => {
                return {
                    label: ele?.name, value: ele?._id, ...ele
                }
            })
            dispatch({
                type: actionTypes.SET_ALL_BILL_CATEGORY_LIST,
                payload: resp.data.data,
            });
            getAllBillSubCategoryList(categoryOptions)
        }
    }

    const getAllBillSubCategoryList = async (catOptions = []) => {
        let resp = await API.serviceList({});
        if (resp?.data?.status === "Success" && resp?.data?.statusCode) {
            const allSubCategories = resp?.data?.data
            setAllLocalSubCategories(allSubCategories)
            dispatch({
                type: actionTypes.SET_ALL_BILL_SUB_CATEGORY_LIST,
                payload: allSubCategories,
            });
            const defaultConsultation = catOptions.find(ele => ele?.systemDefault)
            const billData = { defaultConsultation, catOptions, allSubCategories }
            if (patientType === "new") {
                if (allState?.formData?.patientId)
                    getPatientBillList(billData, allState?.formData?.patientId)
                else
                    fillNewPatientDefaultBillingInfo(billData)
            }
            if (patientType === "old")
                handleOldPatientBillingInfo(billData)


        }
    }

    const fillNewPatientDefaultBillingInfo = (billData) => {
        setBillCategory(billData?.defaultConsultation)
        setBillCategoryOptions(billData?.catOptions)
        const filteredSubcategories = billData?.allSubCategories?.filter((subCat) => subCat?.categoryId?._id === billData?.defaultConsultation?._id)
        let filteredBillSubCategoryOptions = filteredSubcategories.map((ele) => {
            return {
                label: ele?.name, value: ele?._id, ...ele
            }
        })
        const checkForServiceAlreadyAdded = false
        if (!allState?.formData?.econsultation) {
            const searchStr = "Consultation New";
            const opdConsultation = filteredBillSubCategoryOptions.find(ele => ele?.systemDefault && ele?.systemDefaultName === searchStr)
            setBillSubCategory(opdConsultation)
            addServiceToBill(opdConsultation, checkForServiceAlreadyAdded);
        }
        if (allState?.formData?.econsultation) {
            const searchStr = "Online Consultation New";
            const onlineConsultation = filteredBillSubCategoryOptions.find(ele => ele?.systemDefault && ele?.systemDefaultName === searchStr)
            setBillSubCategory(onlineConsultation)
            addServiceToBill(onlineConsultation, checkForServiceAlreadyAdded);
        }
        setBillType("Paid")
        setBillSubCategoryOptions(filteredBillSubCategoryOptions)
    }

    const handleOldPatientBillingInfo = (billData = null) => {
        let lastVisitDate = null;

        if (allProps?.patientData?.visitCountData?.length) {
            const [{ createdAt, lastVisitDate: lastDate }] = allProps.patientData.visitCountData;

            const today = new Date();
            const createdDate = new Date(createdAt);

            const isSameDay =
                today.getFullYear() === createdDate.getFullYear() &&
                today.getMonth() === createdDate.getMonth() &&
                today.getDate() === createdDate.getDate();

            lastVisitDate = isSameDay ? lastDate : createdAt;
            console.log(lastVisitDate, allProps, isSameDay, "----lastVisitDate")
        }

        const selectedPatient = {
            lastVisitDate: lastVisitDate,
            createdAt: allProps?.patientData?.createdAt,
        }
        const billType = getBillingType(selectedPatient)
        console.log(billType, "----billType")

        if (billType === "Free") {
            const filteredCategoryOptions = billData?.catOptions?.filter((ele) => ele?.systemDefault !== true)
            handleFreePatient()
        }
        if (billType === "Paid") {
            // if (parentComponent === "dropDownSearch" || parentComponent === "headerlinks") {
            //     getPatientBillList(billData, allState?.formData?.patientId)
            // }
            // if (parentComponent === "billing") {
            //     getPatientBillList(billData, allState?.formData?.patientId)
            // }
            getPatientBillList(billData, allState?.formData?.patientId)
        }
    }

    const handleNewPatientDefaultBillingInfo = () => {
        const catOptions = billingReduxData?.billCategoryList.map((ele) => {
            return {
                label: ele?.name, value: ele?._id, ...ele
            }
        })
        const allSubCategories = billingReduxData?.billSubCategoryList
        const defaultConsultation = catOptions.find(ele => ele?.systemDefault)
        const billData = { defaultConsultation, catOptions, allSubCategories }
        fillNewPatientDefaultBillingInfo(billData)
    }

    const handleOldPatientDefaultBillingInfo = (billData) => {
        fillOldPatientDefaultBillingInfo(billData)
    }

    const fillOldPatientDefaultBillingInfo = (billData) => {
        setBillCategory(billData?.defaultConsultation)
        setBillCategoryOptions(billData?.catOptions)
        const filteredSubcategories = billData?.allSubCategories?.filter((subCat) => subCat?.categoryId?._id === billData?.defaultConsultation?._id)
        let filteredBillSubCategoryOptions = filteredSubcategories.map((ele) => {
            return {
                label: ele?.name, value: ele?._id, ...ele
            }
        })
        const checkForServiceAlreadyAdded = false
        if (!allState?.formData?.econsultation) {
            const searchStr = "Consultation Old";
            const opdConsultation = filteredBillSubCategoryOptions.find(ele => ele?.systemDefault && ele?.systemDefaultName === searchStr)
            console.log(opdConsultation, "----opd")
            setBillSubCategory(opdConsultation)
            addServiceToBill(opdConsultation, checkForServiceAlreadyAdded);
        }
        if (allState?.formData?.econsultation) {
            const searchStr = "Online Consultation Old";
            const onlineConsultation = filteredBillSubCategoryOptions.find(ele => ele?.systemDefault && ele?.systemDefaultName === searchStr)
            setBillSubCategory(onlineConsultation)
            addServiceToBill(onlineConsultation, checkForServiceAlreadyAdded);
        }
        setBillType("Paid")
        setBillSubCategoryOptions(filteredBillSubCategoryOptions)
    }



    const getBillingType = (patientDetails) => {


        if (patientDetails) {
            const { lastVisitDate, createdAt } = patientDetails;
            let lastVisitDateToUse = createdAt;

            // Agar lastVisitDate hai to use karein, nahi to createdAt
            if (lastVisitDate) lastVisitDateToUse = lastVisitDate;
            lastVisitDateToUse = moment(lastVisitDateToUse).format("YYYY-MM-DD");

            let date1 = new Date(lastVisitDateToUse);
            let date2 = new Date();
            let billingCycle = localStorage.getItem("billingCycle");

            // Agar billing cycle local storage se mile to use karein
            if (billingCycle) {
                billingCycle = JSON.parse(billingCycle);
            }

            // Billing cycle ko add karen
            date1.setDate(date1.getDate() + billingCycle);

            // Moment ko use karke date ko format karna
            date1 = moment(date1).format("YYYY-MM-DD");
            date2 = moment(date2).format("YYYY-MM-DD");

            let billType = "Paid";  // Default to Paid

            // Agar lastVisitDateToUse null hai to Paid
            if (lastVisitDateToUse == null) {
                billType = "Paid";
            } else if (lastVisitDateToUse === date2) {
                // Agar aaj ki date hai to Paid
                billType = "Paid";
            } else if (new Date(date1) > new Date(date2)) {
                // Agar date1 (last visit + billing cycle) aaj se bada hai to Free
                billType = "Free";
            } else {
                // Agar date1 (last visit + billing cycle) aaj se chhota hai to Paid
                billType = "Paid";
            }

            return billType;
        }

    }

    const handleFreePatient = () => {
        setBillCategory(null)
        setBillSubCategory(null)
        setBillCategoryOptions([]);
        setBillSubCategoryOptions([]);
        setPaymentMode("Cash")
        setBillType("Free")
        clearBillDetails()
        // handlePaymentMode("")
    }

    const getPatientBillList = async (billData = null, patientId = "") => {
        let payload = {
            "limit": 1000,
            "offset": 0,
            "order": "createdAt",
            "direction": "desc",
            "search": "",
            startDate: moment().format('YYYY-MM-DD'),
            endDate: moment().format('YYYY-MM-DD'),
            patientId: patientId,
        }
        let resp = await API.billingList(payload)
        if (resp?.data?.status === "Success" && resp?.data?.statusCode === 200) {
            if (resp?.data?.data?.length > 0) {
                const bills = resp?.data?.data
                let updatedBllData = { ...billData, bills }
                let shouldSetBillTypeFree = false;
                if (parentComponent !== "billing" && patientType === "old" || patientType === "new") {
                    console.log(updatedBllData, "updatedBillData")

                    // Filter subcategories with systemDefault = true
                    const systemDefaultSubCategories = updatedBllData?.allSubCategories?.filter(
                        subCat => subCat?.systemDefault === true
                    ) || [];

                    // Check if any bill has services that match system default subcategories


                    bills.forEach(bill => {
                        if (bill?.services && Array.isArray(bill.services)) {
                            bill.services.forEach(service => {
                                // Check if serviceId matches any system default subcategory _id
                                const matchingSystemDefault = systemDefaultSubCategories.find(
                                    subCat => subCat._id === service.serviceId
                                );

                                if (matchingSystemDefault) {
                                    shouldSetBillTypeFree = true;
                                }
                            });
                        }
                    });

                    // If any service matches system default subcategory, set billType to "Free"
                    if (shouldSetBillTypeFree) {
                        setBillType("Free");
                        const filteredCategoryOptions = updatedBllData?.catOptions?.filter((ele) => ele?.systemDefault !== true)
                        setBillCategoryOptions(filteredCategoryOptions || []);
                        handleFreePatient();
                    }
                }
                if (!shouldSetBillTypeFree && patientType === "old") {
                    fillOldPatientLatestBillDetails(updatedBllData)
                }
            }
            if (resp?.data?.data?.length === 0) {
                if (patientType === "new") {
                    handleNewPatientDefaultBillingInfo()
                }
                if (patientType === "old") {
                    handleOldPatientDefaultBillingInfo(billData)
                }
            }


        }
    }

    const fillOldPatientLatestBillDetails = (billData = null) => {
        const billOptions = billData?.bills?.map((ele) => {
            return {
                label: ele?.billNumber, value: ele?._id, ...ele
            }
        })
        const latestPatientBill = billOptions[0]
        onBillingDisabledChange(true);
        setBillCategoryOptions(billData?.catOptions)
        setBillOptions(billOptions)
        setLatestBill(latestPatientBill)
        setBillType("Paid")
        setPaymentMode(latestPatientBill?.paymentMode)
        handlePaymentMode(latestPatientBill?.paymentMode)
        handleFillOldPatientLatestBillDetails(latestPatientBill, billData?.allSubCategories)
    }

    const handleConsultationType = () => {
        let changedPurpose = {}
        let changedBillCategory = {}
        if (billType === "Paid") {
            const defaultConsultation = allLocalCategories.find(ele => ele?.systemDefault)
            const defaultConsultationServices = allLocalSubCategories?.filter((subCat) => subCat?.categoryId?._id === defaultConsultation?._id)
            let defaultConsultationOptions = defaultConsultationServices.map((ele) => {
                return {
                    label: ele?.name, value: ele?._id, ...ele
                }
            })
            let updatedServices = [...allState.services]; // Create a copy of the services array to avoid mutation
            const { parentComponent } = allProps
            if (["headerlinks", "dropDownSearch", "appointment"].includes(parentComponent)) {
                if (!allState?.formData?.patientId) {
                    // Case 1: PatientId is missing and e.target.value is true
                    if (allState?.formData?.econsultation) {
                        console.log("asdsadsad", defaultConsultationOptions);
                        const onlineConsultationNew = defaultConsultationOptions.find(option => option.systemDefaultName === "Online Consultation New");
                        changedBillCategory = billCategoryOptions?.find((ele) => ele?._id === onlineConsultationNew?.categoryId?._id)
                        changedPurpose = onlineConsultationNew
                        updatedServices = updatedServices.map(service => {
                            console.log(service, onlineConsultationNew, "----service")
                            if (service.systemDefaultName === "Consultation New") {
                                if (onlineConsultationNew) {
                                    return {
                                        ...service,
                                        item: onlineConsultationNew.label,
                                        serviceId: onlineConsultationNew.value,
                                        price: onlineConsultationNew.price,
                                        quantity: 1,
                                        discount: 0,
                                        systemDefaultName: onlineConsultationNew.systemDefaultName
                                    };
                                }
                            }
                            return service; // Return the original service if no match
                        });

                        // If no matching service was found, add the new one at index 0
                        if (!updatedServices.some(service => service.systemDefaultName === "Online Consultation New")) {
                            if (onlineConsultationNew) {
                                updatedServices = [{
                                    item: onlineConsultationNew.label,
                                    serviceId: onlineConsultationNew.value,
                                    price: onlineConsultationNew.price,
                                    quantity: 1,
                                    discount: 0,
                                    systemDefaultName: onlineConsultationNew.systemDefaultName
                                }, ...updatedServices];
                            }
                        }
                    }
                    // Case 2: PatientId is missing and e.target.value is false
                    else {
                        const consultationNew = defaultConsultationOptions.find(option => option.systemDefaultName === "Consultation New");
                        changedBillCategory = billCategoryOptions?.find((ele) => ele?._id === consultationNew?.categoryId?._id)
                        changedPurpose = consultationNew
                        updatedServices = updatedServices.map(service => {
                            if (service.systemDefaultName === "Online Consultation New") {

                                if (consultationNew) {
                                    return {
                                        ...service,
                                        item: consultationNew.label,
                                        serviceId: consultationNew.value,
                                        price: consultationNew.price,
                                        quantity: 1,
                                        discount: 0,
                                        systemDefaultName: consultationNew.systemDefaultName
                                    };
                                }
                            }
                            return service; // Return the original service if no match
                        });

                        // If no matching service was found, add the new one at index 0
                        if (!updatedServices.some(service => service.systemDefaultName === "Consultation New")) {
                            if (consultationNew) {
                                updatedServices = [{
                                    item: consultationNew.label,
                                    serviceId: consultationNew.value,
                                    price: consultationNew.price,
                                    quantity: 1,
                                    discount: 0,
                                    systemDefaultName: consultationNew.systemDefaultName
                                }, ...updatedServices];

                            }
                        }
                    }
                }
                else {

                    // if (!latestBill) {
                    // Case 3: PatientId exists and e.target.value is true
                    if (allState?.formData?.econsultation) {
                        const onlineConsultationOld = defaultConsultationOptions.find(option => option.systemDefaultName === "Online Consultation Old");
                        changedBillCategory = billCategoryOptions?.find((ele) => ele?._id === onlineConsultationOld?.categoryId?._id)
                        changedPurpose = onlineConsultationOld
                        updatedServices = updatedServices.map(service => {
                            if (["Consultation Old", "Consultation New", "Online Consultation New"].includes(service.systemDefaultName)) {
                                const onlineConsultationOld = defaultConsultationOptions.find(option => option.systemDefaultName === "Online Consultation Old");
                                if (onlineConsultationOld) {
                                    return {
                                        ...service,
                                        item: onlineConsultationOld.label,
                                        serviceId: onlineConsultationOld.value,
                                        price: onlineConsultationOld.price,
                                        quantity: 1,
                                        discount: 0,
                                        systemDefaultName: onlineConsultationOld.systemDefaultName
                                    };
                                }
                            }
                            return service; // Return the original service if no match
                        });

                        // If no matching service was found, add the new one at index 0
                        if (!updatedServices.some(service => service.systemDefaultName === "Online Consultation Old")) {
                            if (onlineConsultationOld) {
                                updatedServices = [{
                                    item: onlineConsultationOld.label,
                                    serviceId: onlineConsultationOld.value,
                                    price: onlineConsultationOld.price,
                                    quantity: 1,
                                    discount: 0,
                                    systemDefaultName: onlineConsultationOld.systemDefaultName
                                }, ...updatedServices];
                            }
                        }
                    }
                    // Case 4: PatientId exists and e.target.value is false
                    else {
                        const consultationOld = defaultConsultationOptions.find(option => option.name === "Consultation Old");
                        changedBillCategory = billCategoryOptions?.find((ele) => ele?._id === consultationOld?.categoryId?._id)
                        changedPurpose = consultationOld
                        updatedServices = updatedServices.map(service => {
                            if (["Online Consultation Old", "Consultation New", "Online Consultation New"].includes(service.systemDefaultName)) {
                                if (consultationOld) {
                                    return {
                                        ...service,
                                        item: consultationOld.label,
                                        serviceId: consultationOld.value,
                                        price: consultationOld.price,
                                        quantity: 1,
                                        discount: 0,
                                        systemDefaultName: consultationOld.systemDefaultName
                                    };
                                }
                            }
                            return service; // Return the original service if no match
                        });

                        // If no matching service was found, add the new one at index 0
                        if (!updatedServices.some(service => service.systemDefaultName === "Consultation Old")) {
                            if (consultationOld) {
                                updatedServices = [{
                                    item: consultationOld.label,
                                    serviceId: consultationOld.value,
                                    price: consultationOld.price,
                                    quantity: 1,
                                    discount: 0,
                                    systemDefaultName: consultationOld.systemDefaultName
                                }, ...updatedServices];

                            }
                        }
                    }
                    // }
                }
            }

            // Now update the state with the modified services array
            setBillCategory(changedBillCategory)
            setBillSubCategory(changedPurpose)
            setBillSubCategoryOptions(defaultConsultationOptions)
            handleUpdateServicesOnConsultationChange(updatedServices)
            // this.setState({
            //     services: updatedServices,  // Set updated services array to state
            //     billSubCategory: changedPurpose,
            //     billCategory: changedBillCategory,
            //     billSubCategoryOptions: defaultConsultationServices
            // });
        }
    }

    const handleSearchedPatient = (searchedPatient) => {
        if (searchedPatient) {
            console.log(searchedPatient, "----searchedPatient")
            let lastVisitDate = null;

            if (searchedPatient?.visitCountData?.length) {
                const [{ createdAt, lastVisitDate: lastDate }] = searchedPatient.visitCountData;

                const today = new Date();
                const createdDate = new Date(createdAt);

                const isSameDay =
                    today.getFullYear() === createdDate.getFullYear() &&
                    today.getMonth() === createdDate.getMonth() &&
                    today.getDate() === createdDate.getDate();

                lastVisitDate = isSameDay ? lastDate : createdAt;
                console.log(lastVisitDate, allProps, isSameDay, "----lastVisitDate")
            }

            const selectedPatient = {
                lastVisitDate: lastVisitDate,
                createdAt: searchedPatient?.createdAt,
            }
            const billingType = getBillingType(selectedPatient)
            if (billingType === "Free")
                handleFreePatient()
            if (billingType === "Paid")
                handleInitiateBillingProcess()
        }
    }

    const handleInitiateBillingProcess = () => {
        console.log(billingReduxData, patientType, allState, '-----patientType')
        if (billingReduxData?.billCategoryList?.length === 0 && patientType === "new")
            getBillCategoryList()
        if (billingReduxData?.billCategoryList?.length > 0 && patientType === "new") {
            if (allState?.formData?.patientId) {
                const catOptions = billingReduxData?.billCategoryList.map((ele) => {
                    return {
                        label: ele?.name, value: ele?._id, ...ele
                    }
                })
                const allSubCategories = billingReduxData?.billSubCategoryList
                const defaultConsultation = catOptions.find(ele => ele?.systemDefault)
                const billData = { defaultConsultation, catOptions, allSubCategories }
                getPatientBillList(billData, allState?.formData?.patientId)
            } else {
                handleNewPatientDefaultBillingInfo()
            }
        }
        if (billingReduxData?.billCategoryList?.length === 0 && patientType === "old")
            getBillCategoryList()
        if (billingReduxData?.billCategoryList?.length > 0 && patientType === "old") {
            const catOptions = billingReduxData?.billCategoryList.map((ele) => {
                return {
                    label: ele?.name, value: ele?._id, ...ele
                }
            })
            const allSubCategories = billingReduxData?.billSubCategoryList
            const defaultConsultation = catOptions.find(ele => ele?.systemDefault)
            const billData = { defaultConsultation, catOptions, allSubCategories }
            handleOldPatientBillingInfo(billData)
        }
    }

    useEffect(() => {
        const searchedPatient = allState?.selectedPatient
        if (searchedPatient)
            handleSearchedPatient(searchedPatient)
        if (!searchedPatient) {
            // setBillSubCategory(null)
            // setBillCategory(null)
            // setBillSubCategoryOptions([])
            // setBillType("")
            console.log("no patient selected", allState)
            handleInitiateBillingProcess()
        }

    }, [allState?.selectedPatient])

    useEffect(() => {
        handleConsultationType()
    }, [allState?.formData?.toggleConsultation])

    useEffect(() => {
        handleInitiateBillingProcess()
    }, [])
    console.log(billCategory, allProps, allState, patientType, "----billCategory")
    return (
        <>
            <FormGroup>
                <Col componentClass={ControlLabel} sm={12} md={12}>
                    <strong> Billing Info </strong>
                </Col>
            </FormGroup>

            {/* {billOptions.length > 0 && (
                <FormGroup>
                    <Col componentClass={ControlLabel} sm={12} md={5}>
                        Bills
                    </Col>
                    <Col sm={12} md={7}>
                        <select
                            className="form-control"
                            value={latestBill?.value || ""}
                            onChange={(e) => {
                                const selected = billOptions.find(option => option.value === e.target.value);
                                handleBill(selected || null);
                            }}
                            disabled={isBillingDisabled}
                        >
                            <option value="">Select a Bill</option>
                            {billOptions.map((option) => (
                                <option key={option.value} value={option.value}>
                                    {option.label}
                                </option>
                            ))}
                        </select>
                    </Col>
                </FormGroup>
            )} */}


            <FormGroup>
                <Col componentClass={ControlLabel} sm={12} md={5}>
                    Bill Type
                </Col>
                <Col sm={12} md={7}>
                    <select
                        className="form-control"
                        name="billType"
                        onChange={handleChange}
                        value={billType}
                        disabled={isBillingDisabled}
                    >
                        <option value="">Select Bill Type</option>
                        {billTypeOptions.map((item) => (
                            <option key={item.value} value={item.label}>
                                {item.label}
                            </option>
                        ))}
                    </select>
                </Col>
            </FormGroup>

            <FormGroup>
                <Col componentClass={ControlLabel} sm={12} md={5}>
                    Bill Category
                </Col>
                <Col sm={12} md={7}>
                    <select
                        className="form-control"
                        value={billCategory?.value || ""}
                        onChange={(e) => {
                            if (!isBillingDisabled) {
                                const selected = billCategoryOptions.find(
                                    option => option.value === e.target.value
                                );
                                if (selected) {
                                    handleBillCategory(selected);
                                }
                            }
                        }}
                        disabled={isBillingDisabled}
                    >
                        <option value="">Select Bill Category</option>

                        {/** 👇 yaha filter apply karenge */}
                        {billCategoryOptions
                            .filter(option => {
                                const categoryServices = allLocalSubCategories.filter(
                                    service =>
                                        service?.categoryId?._id === option?.value &&
                                        service?.isActive
                                );
                                return categoryServices.length > 0 && option?.isActive;
                            })
                            .map(option => (
                                <option key={option.value} value={option.value}>
                                    {option.label}
                                </option>
                            ))}
                    </select>
                </Col>
            </FormGroup>


            <FormGroup>
                <Col componentClass={ControlLabel} sm={12} md={5}>
                    Purpose
                </Col>
                <Col sm={12} md={7}>
                    <select
                        className="form-control"
                        value={billSubCategory?.value || ""}
                        onChange={(e) => {
                            if (!isBillingDisabled) {
                                const selected = billSubCategoryOptions.find(
                                    option => option.value === e.target.value
                                );
                                if (selected) {
                                    setBillSubCategory(selected);
                                    const checkForServiceAlreadyAdded = true;
                                    addServiceToBill(selected, checkForServiceAlreadyAdded);
                                }
                            }
                        }}
                        disabled={isBillingDisabled}
                    >
                        <option value="">Select Purpose</option>
                        {/* {billSubCategoryOptions.map((option) => (
                            <option
                                key={option.value}
                                value={option.value}
                            >
                                {option.label}
                            </option>
                        ))} */}
                        {billSubCategoryOptions.filter(option => option.isActive).map((option) => {
                            const isEConsultation = allState?.formData?.econsultation;
                            const label = option.label?.toLowerCase();
                            const systemDefaultName = option?.systemDefaultName?.toLowerCase();

                            // 👇 Check if current category is Consultation


                            // 👇 Only apply logic if category is Consultation
                            let shouldEnable = true;

                            if (billCategory?.systemDefault) {
                                shouldEnable =
                                    (patientType === "new" &&
                                        isEConsultation &&
                                        systemDefaultName === "online consultation new") ||
                                    (patientType === "new" &&
                                        !isEConsultation &&
                                        systemDefaultName === "consultation new") ||
                                    (patientType === "old" &&
                                        isEConsultation &&
                                        systemDefaultName === "online consultation old") ||
                                    (patientType === "old" &&
                                        !isEConsultation &&
                                        systemDefaultName === "consultation old");
                            }

                            return (
                                <option
                                    key={option.value}
                                    value={option.value}
                                    disabled={!shouldEnable}
                                >
                                    {option.label}
                                </option>
                            );
                        })}
                    </select>
                </Col>
            </FormGroup>

            <FormGroup>
                <Col componentClass={ControlLabel} sm={12} md={5} style={{ height: "30px" }}>
                    Payment Mode
                </Col>
                <Col sm={12} md={7}>
                    <select
                        className="form-control"
                        name="paymentMode"
                        onChange={(e) => {
                            setPaymentMode(e.target.value);
                            handlePaymentMode(e.target.value)
                        }}
                        value={paymentMode}
                    >
                        <option value="Cash">Cash</option>
                        <option value="Card">Card</option>
                        <option value="UPI">UPI</option>
                    </select>
                </Col>
            </FormGroup>

            <FormGroup>
                <Col componentClass={ControlLabel} sm={12} md={5}>
                    Amount Paid
                </Col>
                <Col sm={12} md={7}>
                    <FormControl
                        type="number"
                        name="totalPaidAmount"
                        id="totalPaidAmount"

                        value={totalPaidAmount || ""}
                        onChange={(e) => {
                            handleTotalPaidAmount(e?.target?.value)
                        }}
                        onKeyDown={(e) => {
                            if (e.key === "ArrowDown" && totalPaidAmount <= 0) {
                                e.preventDefault();
                            }
                        }}
                        min="0"
                        autoComplete="off"
                        disabled={isBillingDisabled}
                    />
                    {totalPaidAmountError && (
                        <div className="errorMsg" style={{ color: "red" }}>
                            {totalPaidAmountError}
                        </div>
                    )}
                </Col>
            </FormGroup>
        </>
    );
};

export default BillingInfo;
